import { TransferPalletBalance } from 'interfaces';

export const checkIfDefinedSomePalletsToPickUp = (palletsToPickUpData: TransferPalletBalance[]) =>
   palletsToPickUpData.some(
      palletsToPickUpDataItem =>
         palletsToPickUpDataItem.invalidAvailablePallets ||
         palletsToPickUpDataItem.validAvailablePallets,
   );
